<template>
  <div>
    <div class="mb-4">
      <h2 class="text-lg font-semibold text-gray-900 dark:text-white">Database Beheer</h2>
      <p class="text-sm text-gray-500 dark:text-gray-400 mt-1">
        Beheer en wis database gegevens.
        <span class="text-red-600 dark:text-red-400 font-medium"
          >Let op: verwijderde gegevens kunnen niet worden hersteld!</span
        >
      </p>
    </div>

    <!-- Loading state -->
    <div v-if="isLoading" class="text-center py-12">
      <div
        class="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 dark:border-blue-400 mx-auto"
      ></div>
      <p class="mt-4 text-gray-600 dark:text-gray-400">Laden...</p>
    </div>

    <!-- Database Tables -->
    <div v-else class="space-y-4">
      <!-- Table Cards -->
      <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        <TableCard
          v-for="table in tables"
          :key="table.key"
          :table="table"
          :record-count="stats[table.key] ?? 0"
          :disabled="isClearing"
          @clear="$emit('clear-table', table)"
        />
      </div>

      <!-- Clear All Button -->
      <div class="mt-8 pt-6 border-t border-gray-200 dark:border-gray-700">
        <div
          class="bg-red-50 dark:bg-red-900/30 border border-red-200 dark:border-red-800 rounded-lg p-4"
        >
          <div class="flex items-start gap-4">
            <div class="flex-shrink-0">
              <ExclamationTriangleIcon class="h-6 w-6 text-red-600 dark:text-red-400" />
            </div>
            <div class="flex-1">
              <h3 class="font-medium text-red-900 dark:text-red-300">Alle Gegevens Wissen</h3>
              <p class="text-sm text-red-700 dark:text-red-400 mt-1">
                Dit verwijdert ALLE gegevens uit de database (behalve gebruikers). Deze actie kan
                niet ongedaan worden gemaakt.
              </p>
              <button
                @click="$emit('clear-all')"
                :disabled="isClearing"
                class="mt-4 bg-red-600 text-white hover:bg-red-700 disabled:opacity-50 px-4 py-2 rounded-lg text-sm font-medium transition-colors"
              >
                Alle Gegevens Wissen
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- Refresh Button -->
      <div class="flex justify-end mt-4">
        <button
          @click="$emit('refresh')"
          class="text-blue-600 dark:text-blue-400 hover:text-blue-800 dark:hover:text-blue-300 text-sm font-medium flex items-center gap-1"
        >
          <ArrowPathIcon class="h-4 w-4" />
          Vernieuwen
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ExclamationTriangleIcon, ArrowPathIcon } from '@heroicons/vue/24/outline'
import TableCard from './TableCard.vue'

defineProps({
  tables: {
    type: Array,
    required: true
  },
  stats: {
    type: Object,
    default: () => ({})
  },
  isLoading: {
    type: Boolean,
    default: false
  },
  isClearing: {
    type: Boolean,
    default: false
  }
})

defineEmits(['clear-table', 'clear-all', 'refresh'])
</script>
